import gql from 'graphql-tag'
import {
	Project
} from './query.graphql'

export RootQuery = gql """
	query($projectSlug: String!){
		project(slug: $projectSlug) {
			#{Project}
		}
	}
"""
